export type GetEnvironmentCopyRequestsRequest = {
  envrnmntIdTo: string;
};
